/**
 * Global (non-scene) configuration: registry URL, UI timing, input defaults.
 * Scene-specific data lives in per-scene scene.json manifests (see manifest.ts).
 */

export const globalConfig = {
    /** Scene registry, listing all scenes + the entry scene. */
    registryUrl: '/assets/scenes/registry.json',
    /** Scene fade transition duration (ms). */
    fadeDuration: 450,
    /** Mouse look sensitivity in degrees per pixel. */
    mouseSensitivity: 0.1,
    /** Default field of view. */
    fov: 75
};
